import {Button} from '@kit';

import React from 'react';

import {Link} from '../../lib/routes';
import {useCookieConsent} from './use-cookie-consent';

import css from './cookie-banner.module.css';

export const CookieBanner: React.FC = () => {
	const {consent, accept, decline} = useCookieConsent();

	if (consent !== 'none') return null;

	return (
		<div className={css.banner} role="dialog" aria-label="Использование cookie">
			<p className={css.text}>
				Мы используем cookie Яндекс.Метрики, чтобы понимать, как посетители пользуются сайтом. Без вашего согласия
				они не устанавливаются. Подробнее — в{' '}
				<Link route="privacy" keepQuery={false}>
					политике конфиденциальности
				</Link>
				.
			</p>
			<div className={css.buttons}>
				<Button appearance="outline" onClick={decline}>
					Отклонить
				</Button>
				<Button appearance="primary" onClick={accept}>
					Принять
				</Button>
			</div>
		</div>
	);
};
